import React from 'react';
import PropTypes from 'prop-types';
import { get } from 'lodash-es';
import { connect } from 'react-redux';

import { RatingStars } from 'site-modules/shared/components/rating-stars/rating-stars';
import { getLeadType, getLeadUid } from 'site-modules/shared/components/lead-form/utils/utils';
import { LEAD_TYPES } from 'site-modules/shared/constants/lead-form/lead-form-params';
import { ContentFragment } from 'site-modules/shared/components/content-fragment/content-fragment';

import './card.scss';

export function DealerPriceCardUI({ leadTarget, isMobile = false, inventoryText = '' }) {
  const { dealer, inventory, leadAttributes } = leadTarget;

  const distance = get(leadAttributes, 'distance');
  const dealerInfo = get(inventory, 'dealerInfo', dealer);

  const salesOverallRating = get(dealerInfo, 'displayInfo.salesOverallRating', get(dealerInfo, 'salesRating', 0));
  const salesReviewCount = get(dealerInfo, 'displayInfo.salesReviewCount', get(dealerInfo, 'salesReviewCount', 0));

  const uid = getLeadUid(leadTarget);
  const isInventoryTarget = getLeadType(leadTarget) === LEAD_TYPES.INVENTORY;

  return (
    <div className="d-flex align-items-center justify-content-between">
      <div>
        <div className="text-gray-darker heading-4 fw-normal" id={uid}>
          {dealerInfo.name}
        </div>
        <div className="small mt-0_25">
          <RatingStars rating={salesOverallRating} className="text-primary-darker me-0_25" />
          <span>({salesReviewCount})</span>
        </div>
        {distance > 0 && <div className="small text-gray-dark mt-0_25">{distance.toFixed(1)} miles away</div>}
        {isInventoryTarget && isMobile && inventoryText && (
          <ContentFragment classes="small mt-0_5">{inventoryText}</ContentFragment>
        )}
      </div>
      {isInventoryTarget && !isMobile && inventoryText && (
        <ContentFragment classes="small me-0_5">{inventoryText}</ContentFragment>
      )}
    </div>
  );
}

DealerPriceCardUI.propTypes = {
  leadTarget: PropTypes.shape({
    inventory: PropTypes.shape({}),
    dealer: PropTypes.shape({}),
    leadAttributes: PropTypes.shape({
      primary: PropTypes.bool.isRequired,
      selected: PropTypes.bool.isRequired,
      distance: PropTypes.number,
    }).isRequired,
  }).isRequired,
  inventoryText: PropTypes.string,
  isMobile: PropTypes.bool,
};

export const mapStateToProps = state => ({
  isMobile: state.mobile,
});

export const DealerPriceCard = connect(mapStateToProps)(DealerPriceCardUI);
